import * as React from 'react';
import './Box.scss';
import { Button, Card, Divider, Empty, Space, Typography } from 'antd';

const { Title, Text } = Typography;

// export default Box;
interface OfferLettersCardProps {
  title?: string | React.ReactNode;
  subTitle?: string;
  className?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
  isNew?: boolean;
}

const Box: React.FC<OfferLettersCardProps> = ({
  title,
  actions,
  children,
  isNew,
  subTitle
}) => {
  return (
    <Card
      title={title && <Space direction="horizontal" className="display_card">
        <div>
          <Title level={5} style={{ margin: 0, lineHeight: 1.2 }}>
            {title}
            {isNew && <span className="new-badge">New</span>}
          </Title>
          {subTitle && <Text type='secondary'>{subTitle}</Text>}
        </div>
        {actions}
      </Space>}
    >
      {children}
    </Card>
  );
};

export default Box;

